import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] border-t border-[#1a1a1a]" data-testid="footer">
      <div className="container-cni py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img 
                src="/images/logo-cni.png" 
                alt="Colegio Nacional de Inmobiliarios" 
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed">
              Colegio Nacional de Inmobiliarios. Registro público verificable de profesionales inmobiliarios en México.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-manrope font-semibold text-white mb-4 text-sm">Navegación</h4>
            <ul className="space-y-2">
              <li><Link to="/buscar" className="text-sm text-gray-500 hover:text-amber-400 transition-colors">Buscar Profesional</Link></li>
              <li><Link to="/rangos" className="text-sm text-gray-500 hover:text-amber-400 transition-colors">Rangos del Colegio</Link></li>
              <li><Link to="/oferta-academica" className="text-sm text-gray-500 hover:text-amber-400 transition-colors">Oferta Académica</Link></li>
              <li><Link to="/membresia" className="text-sm text-gray-500 hover:text-amber-400 transition-colors">Membresía</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-manrope font-semibold text-white mb-4 text-sm">Recursos</h4>
            <ul className="space-y-2">
              <li><Link to="/reglas-marca" className="text-sm text-gray-500 hover:text-amber-400 transition-colors">Reglas de la Marca</Link></li>
              <li><Link to="/como-funciona" className="text-sm text-gray-500 hover:text-amber-400 transition-colors">Cómo Funciona</Link></li>
              <li><Link to="/asociaciones" className="text-sm text-gray-500 hover:text-amber-400 transition-colors">Asociaciones</Link></li>
              <li><Link to="/contacto" className="text-sm text-gray-500 hover:text-amber-400 transition-colors">Contacto</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-manrope font-semibold text-white mb-4 text-sm">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/privacidad" className="text-sm text-gray-500 hover:text-amber-400 transition-colors">Aviso de Privacidad</Link></li>
              <li><Link to="/terminos" className="text-sm text-gray-500 hover:text-amber-400 transition-colors">Términos y Condiciones</Link></li>
            </ul>
          </div>
        </div>

        {/* SEP/CONOCER Message */}
        <div className="mt-8 pt-8 border-t border-[#1a1a1a]">
          <p className="text-xs text-gray-600 text-center max-w-3xl mx-auto">
            El Colegio Nacional de Inmobiliarios impulsa la profesionalización del sector mediante estándares de formación y certificación, 
            en colaboración con asociaciones, instituciones educativas y entidades acreditadas para certificaciones federales avaladas por SEP y CONOCER.
          </p>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-[#1a1a1a]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-600">
              © {currentYear} Colegio Nacional de Inmobiliarios. Todos los derechos reservados.
            </p>
            <p className="text-xs text-gray-700">
              Marca Colectiva registrada ante el IMPI por U DE PI MÉXICO (UPIM)
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
